import { FilterValue } from "../Filters/FilterValue";
import {
  SWAYY_CHANNEL_OPTIONS,
  SwayyStatusTone,
} from "../SwayyOrder/SwayyOrderFilters";
import { SwayyCouponState } from "./SwayyCoupon";

export const SWAYY_COUPON_STATUS_ALL_TAB = "all";
export const SWAYY_COUPON_STATUS_DEFAULT_TAB = "active";

export const SWAYY_COUPON_STATUS_OPTIONS: FilterValue[] = [
  { id: "active", value: "Active" },
  { id: "inactive", value: "Inactive" },
  { id: "expired", value: "Expired" },
  { id: "exhausted", value: "Exhausted" },
];

export const SWAYY_COUPON_STATUS_TABS: FilterValue[] = [
  { id: SWAYY_COUPON_STATUS_ALL_TAB, value: "All" },
  ...SWAYY_COUPON_STATUS_OPTIONS,
];

export const SWAYY_COUPON_CHANNEL_OPTIONS: FilterValue[] = [
  ...SWAYY_CHANNEL_OPTIONS,
  { id: "both", value: "Both" },
];

export const SWAYY_COUPON_DISCOUNT_TYPE_OPTIONS: FilterValue[] = [
  { id: "percent", value: "Percent" },
  { id: "fixed", value: "Fixed" },
  { id: "free_shipping", value: "Free shipping" },
];

export const SWAYY_COUPON_ACTIVE_OPTIONS: FilterValue[] = [
  { id: "true", value: "Active" },
  { id: "false", value: "Inactive" },
];

export const getSwayyCouponStatusLabel = (status: string): string =>
  SWAYY_COUPON_STATUS_OPTIONS.find((option) => option.id === status)?.value ??
  status.replace(/_/g, " ");

export const getSwayyCouponStatusTone = (status: string): SwayyStatusTone => {
  const value = (status || "").toLowerCase();
  if (value === "active") return "success";
  if (value === "inactive") return "muted";
  if (value === "expired" || value === "exhausted") return "danger";
  return "warning";
};

export const getSwayyCouponChannelLabel = (channel: string): string =>
  SWAYY_COUPON_CHANNEL_OPTIONS.find((option) => option.id === channel)?.value ??
  channel.toUpperCase();

export const isSwayyCouponState = (value: string): value is SwayyCouponState =>
  SWAYY_COUPON_STATUS_OPTIONS.some((option) => option.id === value);
